module.exports = __webpack_public_path__ + "static/img/female-bg-fr.cd26e229.png";